import { BlogSection } from '@/types/blog';

export const systemabsturz: BlogSection = {
  id: 'systemabsturz',
  title: 'Der Systemabsturz: Wenn das Dashboard lügt',
  content: `
    <p class="mb-4">
      Stell dir vor, in deinem Auto leuchtet die Öldruck-Warnlampe auf. Würdest du einen "Good Vibes Only"-Sticker darüber kleben und hoffen, dass das Problem verschwindet? Sicher nicht. Du würdest anhalten und den Motor prüfen.
    </p>
    
    <p class="mb-4">
      Deine "negativen" Emotionen – Angst, Wut, Trauer, Zweifel – sind deine Öldruck-Warnlampe. Sie sind keine Bugs, die es zu unterdrücken gilt, sondern kritische Datenpunkte. Dein Betriebssystem signalisiert eine Dissonanz, die deine Aufmerksamkeit erfordert. "Toxische Positivität" ist der Versuch, den Sticker über die Warnlampe zu kleben.
    </p>
    
    <p class="mb-4">
      Die Wissenschaft liefert uns präzise Beweise, warum das scheitern muss:
    </p>
    
    <div class="mb-6 p-4 bg-joerg-50 dark:bg-joerg-900/20 rounded-lg border-l-4 border-primary">
      <p class="mb-2"><strong>Praxisbeispiel:</strong> Du stehst vor einer wichtigen Präsentation und sagst dir krampfhaft: "Ich bin nicht nervös, ich bin voller Vorfreude." Dein Puls rast.</p>
      
      <p class="mb-0"><strong>Die Wissenschaft dahinter:</strong> Der Psychologe Daniel Wegner hat dies in seinem berühmten "Weißer-Bär-Experiment" nachgewiesen. Der Versuch, einen Gedanken zu unterdrücken, führt paradoxerweise dazu, dass er noch stärker wird (Ironische Prozesstheorie). Dein Gehirn muss ständig prüfen, ob der unerwünschte Gedanke "Nervosität" da ist, und hält ihn dadurch erst recht präsent.</p>
    </div>
    
    <div class="mb-4 p-4 bg-joerg-50 dark:bg-joerg-900/20 rounded-lg border-l-4 border-primary">
      <p class="mb-2"><strong>Praxisbeispiel:</strong> Du willst ein neues Unternehmen gründen und verbringst Wochen damit, dir den finalen Erfolg in allen schillernden Farben auszumalen. Die Energie, den ersten, mühsamen Schritt zu tun, schwindet.</p>
      
      <p class="mb-0"><strong>Die Wissenschaft dahinter:</strong> Gabriele Oettingens Forschung an der NYU zeigt, dass reines positives Fantasieren die Motivation zur Zielerreichung senkt. Dein Gehirn schüttet Entspannungs-Botenstoffe aus, als wäre das Ziel bereits erreicht. Die für die Überwindung von Hindernissen notwendige Energie wird kurzgeschlossen.</p>
    </div>
  `
};
